import getHeader from "./getHeader";
import getAnimation from "./getAnimation";
import getMarketingMessage from "./getMarketingMessage";

const rehydrateState = (currentPage, isLoggedIn, currentUser) => {
    const animation = getAnimation(currentPage, isLoggedIn);
    const header = getHeader(currentPage);
    const marketingMessage = getMarketingMessage(currentUser);

    return {
        header,
        animation,
        marketingMessage
    };
};

export default rehydrateState;
